import { useMemo } from 'react';

import { allCountries } from '~configs';

const useSearchCountry = (searchTerm: string) => {
  const filteredCountries = useMemo(() => {
    if (!searchTerm) return allCountries;
    const lowerCaseSearchTerm = searchTerm.toLowerCase();

    return allCountries.filter(
      (country) =>
        country.name.toLowerCase().includes(lowerCaseSearchTerm) ||
        country.dialCode.toLowerCase().includes(lowerCaseSearchTerm) ||
        country.iso2.toLowerCase().includes(lowerCaseSearchTerm),
    );
  }, [searchTerm]);

  return filteredCountries;
};

export default useSearchCountry;
